export enum MaterialIconSize {
  default = 'default',
  size14 = '14',
  size16 = '16',
  size18 = '18',
  size20 = '20',
  size24 = '24',
  size36 = '36',
}
